module.exports = __webpack_public_path__ + "static/img/sq-wdj.ccf0c920.png";